import 'react-simple-hook-modal/dist/styles.css';
import serviceboy from '../../../images/sites/2.PNG';
import serviceboy2 from '../../../images/serviceboy.PNG'
import React from 'react';
import {
      Modal,
      useModal,
      ModalTransition,
} from 'react-simple-hook-modal';

const Serviceboy = () => {

      const { isModalOpen, openModal, closeModal } = useModal();

      return (
            <div className="col-md-6">
                  <div data-aos="zoom-in-left" style={{height:'400px'}}>
                        <img onClick={openModal} src={serviceboy} data-tip="Click to open Project" className="img-fluid sites link px-5" alt="" srcset="" />
                  </div>

                  <Modal
                        modalClassName="rsm-bg-gray-700"
                        id="any-unique-identifier"
                        isOpen={isModalOpen}
                        transition={ModalTransition.BOTTOM_UP}
                  >
                        <button onClick={closeModal} className='btn'><i style={{ fontSize: '30px' }} class="fas fa-times-circle brand"></i></button>

                        <div className="container">
                              <img className='img-fluid' src={serviceboy2} alt="" />
                              <h2 className='fs-4 mt-3 text-white text-uppercase'>Service Boy</h2>
                              <div className="row mt-2">
                                    <div className="col-sm-6 d-flex justify-content-start">
                                          <a href="https://serviceboybd.web.app/" target="_blank" rel='noreferrer'>
                                                <button style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='btn site-static-button'>VISIT WEBSITE</button>
                                          </a>
                                    </div>
                                    <div className="col-sm-6 d-flex d-flex justify-content-end">
                                          <a href="https://github.com/iamraufu/service-boy-client" target="_blank" rel='noreferrer'>
                                                <button className='btn hvr-sweep-to-right'>KNOW MORE</button>
                                          </a>
                                    </div>
                              </div>
                              <p className='text-white mt-2'>Built an Online Home and Office Service System where any service provider can give services and any client can get services by hourly basis as like as UBER.</p>
                              <ul>
                                    <li>User can log in and book & review services; admin can login and do <b className='brand-link brand'>CRUD operations</b> also can keep track of orders.</li>
                                    <li>Implemented the model with <b className='brand brand-link'> BootStrap5</b>, <b className='brand brand-link'>NodeJS</b>, <b className='brand brand-link'>MongoDB</b>, <b className='brand brand-link'>React</b> and <b className='brand brand-link'>Firebase Authentication</b></li>
                              </ul>
                        </div>
                        <button onClick={closeModal} style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='col-md-12 btn site-static-button'>CLOSE</button>
                  </Modal>

            </div>
      );
};

export default Serviceboy;